export interface Currency {
    id?: number;
    name: string;
    is_active?: boolean;
}

export const defaultCurrency: Currency = {
    name: '',
    is_active: true
};

export interface CurrencyFilters {
    id?: number | null;
    name?: string | '';
    is_active?: boolean | '';
    page: number;
    per_page: number;
    sort: string;
    order: string;
}
